import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import classes from "./Navbar.module.scss";
import logo from "../../../assets/images/logo_blue_white.svg";
import { ReduxApplicationState } from "../../../types/ReduxTypes/ReduxApplicationState";
import { getAppHomePath } from "../../../utils/getAppHomePath";
import { keyDownA11y } from "../../../helpers/accessibility";
import { resetCampaignToCreateState } from "../../../redux/reducers/campaignToCreate";

type NavbarProps = {
  handleOpenSidebar?: () => void;
};

const Navbar: FC<NavbarProps> = ({ handleOpenSidebar }) => {
  const history = useHistory();

  const dispatch = useDispatch();

  const isAuthenticated = useSelector((state: ReduxApplicationState) => state.session.isAuthenticated);

  const handleLogoClick = () => {
    dispatch(resetCampaignToCreateState());
    history.push(getAppHomePath());
  };

  return (
    <AppBar className={classes.container}>
      <Toolbar className={classes.toolBar}>
        <img
          className={classes.headerLogo}
          onClick={handleLogoClick}
          onKeyDown={keyDownA11y(handleLogoClick)}
          src={logo}
          role="presentation"
          id="header-logo"
          alt="header logo"
        />

        {isAuthenticated ? (
          <IconButton className={classes.menuBtn} onClick={handleOpenSidebar}>
            <MenuIcon />
          </IconButton>
        ) : null}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
